import Voolah13500Small from "./voolah-13500-small.png"
import Voolah5000Small from "./voolah-5000-small.png"
import Voolah1000Small from "./voolah-1000-small.png"
import Voolah2800Small from "./voolah-2800-small.png"
import Voolah500Small from "./voolah-500-small.png"
import Voolah13500 from "./voolah-13500.png"
import Voolah1000 from "./voolah-1000.png"
import Voolah2800 from "./voolah-2800.png"
import Voolah5000 from "./voolah-5000.png"
import Voolah500 from "./voolah-500.png"

export const png = {
    Voolah13500Small,
    Voolah1000Small,
    Voolah2800Small,
    Voolah5000Small,
    Voolah500Small,
    Voolah13500,
    Voolah1000,
    Voolah2800,
    Voolah5000,
    Voolah500,
}